/* unplugin-vue-components disabled */import { render } from "./SearchFilter.vue?vue&type=template&id=968186e0&ts=true"
import script from "./SearchFilter.vue?vue&type=script&lang=ts"
export * from "./SearchFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__